module.exports = __webpack_public_path__ + "static/marketing-email-example-6b0682671b4f9c250d7fb41f8f460b75.png";